import { render } from "./WhatsNextBanner.vue?vue&type=template&id=c540613a&scoped=true"
import script from "./WhatsNextBanner.vue?vue&type=script&lang=js"
export * from "./WhatsNextBanner.vue?vue&type=script&lang=js"

import "./WhatsNextBanner.vue?vue&type=style&index=0&id=c540613a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c540613a"]])

export default __exports__